import { Component, Input, OnInit } from "@angular/core";
import { AssistantService } from "../../../services/assistant.service";
import { AssistantActionButton, AssistantActions } from "../../../models";

@Component({
    selector: "app-assistant-popup-action-buttons",
    templateUrl: "./assistant-popup-action-buttons.component.html",
    styleUrls: ["./assistant-popup-action-buttons.component.scss"],
    standalone: false
})
export class AssistantPopupActionButtonsComponent implements OnInit {
  @Input() actions: AssistantActions;

  constructor(private assisantService: AssistantService) {}

  ngOnInit(): void {}

  onActionBtnClick(btn: AssistantActionButton): void {
    this.assisantService.raiseActionButton(btn);
  }
}
